import va from '@vercel/analytics'

const opTypes = ['Search', 'Quick Search', 'Ticket Group Click', 'Cart', 'Purchase', 'Viewed Performer', 'Viewed Venue', 'Viewed Event', 'Buy Button Clicked'] as const

export function track(op: typeof opTypes[number], data?: Record<string, any>) {
  try {
    let track = va.track(op, data)
    console.log('track ' + op)
    console.log(track, data)
  } catch (error) {
    console.error(error)
  }
}
